// Animation property configurations for different effect types
export const ANIMATION_PROPERTY_CONFIGS = {
  move: {
    name: 'Move',
    properties: {
      animationSpeed: 1,
      movementType: 'linear',
      startPosition: { x: 0, y: 0, z: 0 },
      endPosition: { x: 10, y: 0, z: 0 },
      circleCenter: { x: 0, y: 0, z: 0 },
      circleRadius: 5,
      circleAxis: 'z',
      circleDirection: 'clockwise',
      circleStartAngle: 0,
      circleEndAngle: 360,
      circleRevolutions: 1,
      bezierControl1: { x: 5, y: 5, z: 0 },
      bezierControl2: { x: 10, y: -5, z: 0 },
      sineAmplitude: { x: 2, y: 0, z: 0 },
      sineFrequency: 1,
      sinePhase: 0,
      sineAxis: 'x',
      figure8Radius: 5,
      figure8Axis: 'z',
      figure8Speed: 0.5,
      spiralRadius: 5,
      spiralHeight: 5,
      spiralTurns: 2,
      spiralAxis: 'z',
      spiralDirection: 'up',
      relativeToObject: false,
      followPath: false,
      pathSmoothing: 0.5,
      autoRotate: false,
      lookAtTarget: { x: 0, y: 0, z: 0 },
      activeAxes: { x: true, y: false, z: false },
    },
    controls: [
      {
        type: 'number',
        key: 'animationSpeed',
        label: 'Animation Speed',
        min: 0.1,
        max: 10,
        step: 0.1,
      },
      {
        type: 'select',
        key: 'movementType',
        label: 'Movement Type',
        options: ['linear', 'circular', 'bezier', 'sine', 'figure8', 'spiral'],
      },
      {
        type: 'axes',
        key: 'activeAxes',
        label: 'Active Move Axes',
        condition: 'movementType === "linear"',
      },
      {
        type: 'position',
        key: 'startPosition',
        label: 'Start Position',
        condition: 'movementType === "linear"',
      },
      {
        type: 'position',
        key: 'endPosition',
        label: 'End Position',
        condition: 'movementType === "linear"',
      },
      {
        type: 'position',
        key: 'circleCenter',
        label: 'Circle Center',
        condition: 'movementType === "circular"',
      },
      {
        type: 'number',
        key: 'circleRadius',
        label: 'Radius',
        min: 0,
        max: 50,
        step: 0.1,
        condition: 'movementType === "circular"',
      },
      {
        type: 'select',
        key: 'circleAxis',
        label: 'Axis',
        options: ['x', 'y', 'z'],
        condition: 'movementType === "circular"',
      },
      {
        type: 'select',
        key: 'circleDirection',
        label: 'Direction',
        options: ['clockwise', 'counterclockwise'],
        condition: 'movementType === "circular"',
      },
      {
        type: 'number',
        key: 'circleStartAngle',
        label: 'Start Angle',
        min: 0,
        max: 360,
        step: 1,
        condition: 'movementType === "circular"',
      },
      {
        type: 'number',
        key: 'circleEndAngle',
        label: 'End Angle',
        min: 0,
        max: 360,
        step: 1,
        condition: 'movementType === "circular"',
      },
      {
        type: 'number',
        key: 'circleRevolutions',
        label: 'Revolutions',
        min: 0,
        max: 10,
        step: 0.1,
        condition: 'movementType === "circular"',
      },
      {
        type: 'position',
        key: 'bezierControl1',
        label: 'bezierControl1',
        options: ['x', 'y', 'z'],
        condition: 'movementType === "bezier"',
      },
      {
        type: 'position',
        key: 'bezierControl2',
        label: 'bezierControl2',
        options: ['x', 'y', 'z'],
        condition: 'movementType === "bezier"',
      },
      {
        type: 'select',
        key: 'sineAxis',
        label: 'sineAxis',
        options: ['x', 'y', 'z'],
        condition: 'movementType === "sine"',
      },
      {
        type: 'position',
        key: 'sineAmplitude',
        label: 'sineStart',
        condition: 'movementType === "sine"',
      },
      {
        type: 'number',
        key: 'sineFrequency',
        label: 'sineFrequency',
        min: 0,
        max: 10,
        step: 0.1,
        condition: 'movementType === "sine"',
      },
      {
        type: 'number',
        key: 'sinePhase',
        label: 'sinePhase',
        min: 0,
        max: 10,
        step: 0.1,
        condition: 'movementType === "sine"',
      },
      {
        type: 'number',
        key: 'figure8Radius',
        label: 'Radius',
        min: 0,
        max: 10,
        step: 0.1,
        condition: 'movementType === "figure8"',
      },
      {
        type: 'select',
        key: 'figure8Axis',
        label: 'Axis',
        options: ['x', 'y', 'z'],
        condition: 'movementType === "figure8"',
      },
      {
        type: 'number',
        key: 'figure8Speed',
        label: 'Speed',
        min: 0,
        max: 10,
        step: 0.1,
        condition: 'movementType === "figure8"',
      },
      {
        type: 'number',
        key: 'spiralRadius',
        label: 'Radius',
        min: 0,
        max: 10,
        step: 0.1,
        condition: 'movementType === "spiral"',
      },
      {
        type: 'number',
        key: 'spiralHeight',
        label: 'Height',
        min: 0,
        max: 10,
        step: 0.1,
        condition: 'movementType === "spiral"',
      },
      {
        type: 'select',
        key: 'spiralAxis',
        label: 'Axis',
        options: ['x', 'y', 'z'],
        condition: 'movementType === "spiral"',
      },
      {
        type: 'select',
        key: 'spiralDirection',
        label: 'upDirection',
        options: ['clockwise', 'counterclockwise'],
        condition: 'movementType === "spiral"',
      },
    ],
  },

  rotate: {
    name: 'Rotate',
    properties: {
      animationSpeed: 1,
      startRotation: { x: 0, y: 0, z: 0 },
      endRotation: { x: 0, y: 0, z: 360 },
      activeAxes: { x: false, y: false, z: true },
      rotationAxis: { x: false, y: false, z: true },
      rotationAmount: 360,
      rotationSpeed: 1,
      rotationDirection: 'clockwise',
      pivotPoint: { x: 0, y: 0, z: 0 },
      relativeToObject: false,
    },
    controls: [
      {
        type: 'number',
        key: 'animationSpeed',
        label: 'Animation Speed',
        min: 0.1,
        max: 10,
        step: 0.1,
      },
      {
        type: 'axes',
        key: 'activeAxes',
        label: 'Active Rotation Axes',
      },
      {
        type: 'position',
        key: 'startRotation',
        label: 'Start Rotation (degrees)',
        min: -360,
        max: 360,
        step: 1,
      },
      {
        type: 'position',
        key: 'endRotation',
        label: 'End Rotation (degrees)',
        min: -360,
        max: 360,
        step: 1,
      },
      // {
      //   type: 'number',
      //   key: 'rotationAmount',
      //   label: 'Total Rotation Amount',
      //   min: 0,
      //   max: 720,
      //   step: 1,
      // },
      {
        type: 'select',
        key: 'rotationDirection',
        label: 'Direction',
        options: ['clockwise', 'counterclockwise'],
      },
      // {
      //   type: 'position',
      //   key: 'pivotPoint',
      //   label: 'Pivot Point',
      // },
      // {
      //   type: 'checkbox',
      //   key: 'relativeToObject',
      //   label: 'Relative to Object',
      // },
    ],
  },

  scale: {
    name: 'Scale',
    properties: {
      animationSpeed: 1,
      startScale: { x: 1, y: 1, z: 1 },
      endScale: { x: 2, y: 2, z: 2 },
      scaleAxes: { x: true, y: true, z: true },
      uniformScale: false,
      // scaleCenter: { x: 0, y: 0, z: 0 },
    },
    controls: [
      {
        type: 'number',
        key: 'animationSpeed',
        label: 'Animation Speed',
        min: 0.1,
        max: 10,
        step: 0.1,
      },
      {
        type: 'position',
        key: 'startScale',
        label: 'Start Scale',
      },
      {
        type: 'position',
        key: 'endScale',
        label: 'End Scale',
      },
      {
        type: 'axes',
        key: 'scaleAxes',
        label: 'Scale Axes',
      },
      // {
      //   type: 'checkbox',
      //   key: 'uniformScale',
      //   label: 'Uniform Scale',
      // },
      // {
      //   type: 'position',
      //   key: 'scaleCenter',
      //   label: 'Scale Center',
      // },
    ],
  },

  fade: {
    name: 'Fade',
    properties: {
      animationSpeed: 1,
      startOpacity: 1,
      endOpacity: 0,
      fadeType: 'fadeOut',
      fadeSpeed: 1,
    },
    controls: [
      {
        type: 'number',
        key: 'animationSpeed',
        label: 'Animation Speed',
        min: 0.1,
        max: 10,
        step: 0.1,
      },
      {
        type: 'slider',
        key: 'startOpacity',
        label: 'Start Opacity',
        min: 0,
        max: 1,
        step: 0.01,
      },
      {
        type: 'slider',
        key: 'endOpacity',
        label: 'End Opacity',
        min: 0,
        max: 1,
        step: 0.01,
      },
      {
        type: 'select',
        key: 'fadeType',
        label: 'Fade Type',
        options: ['fadeIn', 'fadeOut', 'fadeInOut'],
      },
      {
        type: 'number',
        key: 'fadeSpeed',
        label: 'Fade Speed',
        min: 0.1,
        max: 5,
        step: 0.1,
      },
    ],
  },
  fadein: {
    name: 'Fade In',
    properties: {
      animationSpeed: 1,
      startOpacity: 0,
      endOpacity: 1,
      fadeType: 'fadeOut',
      fadeSpeed: 1,
    },
    controls: [
      {
        type: 'number',
        key: 'animationSpeed',
        label: 'Animation Speed',
        min: 0.1,
        max: 10,
        step: 0.1,
      },
      {
        type: 'slider',
        key: 'startOpacity',
        label: 'Start Opacity',
        min: 0,
        max: 1,
        step: 0.01,
      },
      {
        type: 'slider',
        key: 'endOpacity',
        label: 'End Opacity',
        min: 0,
        max: 1,
        step: 0.01,
      },
      // {
      //   type: 'number',
      //   key: 'fadeSpeed',
      //   label: 'Fade Speed',
      //   min: 0.1,
      //   max: 5,
      //   step: 0.1,
      // },
    ],
  },
  fadeout: {
    name: 'Fade Out',
    properties: {
      animationSpeed: 1,
      startOpacity: 1,
      endOpacity: 0,
      fadeType: 'fadeIn',
      fadeSpeed: 1,
    },
    controls: [
      {
        type: 'number',
        key: 'animationSpeed',
        label: 'Animation Speed',
        min: 0.1,
        max: 10,
        step: 0.1,
      },
      {
        type: 'slider',
        key: 'startOpacity',
        label: 'Start Opacity',
        min: 0,
        max: 1,
        step: 0.01,
      },
      {
        type: 'slider',
        key: 'endOpacity',
        label: 'End Opacity',
        min: 0,
        max: 1,
        step: 0.01,
      },
      // {
      //   type: 'number',
      //   key: 'fadeSpeed',
      //   label: 'Fade Speed',
      //   min: 0.1,
      //   max: 5,
      //   step: 0.1,
      // },
    ],
  },

  bounce: {
    name: 'Bounce',
    properties: {
      animationSpeed: 1,
      bounceHeight: 5,
      bounceCount: 3,
      bounceDecay: 0.5,
      bounceAxis: { x: false, y: true, z: false },
    },
    controls: [
      {
        type: 'number',
        key: 'animationSpeed',
        label: 'Animation Speed',
        min: 0.1,
        max: 10,
        step: 0.1,
      },
      {
        type: 'number',
        key: 'bounceHeight',
        label: 'Bounce Height',
        min: 1,
        max: 50,
        step: 1,
      },
      {
        type: 'number',
        key: 'bounceCount',
        label: 'Bounce Count',
        min: 1,
        max: 10,
        step: 1,
      },
      {
        type: 'slider',
        key: 'bounceDecay',
        label: 'Bounce Decay',
        min: 0,
        max: 1,
        step: 0.01,
      },
      {
        type: 'axes',
        key: 'bounceAxis',
        label: 'Bounce Axis',
      },
    ],
  },

  shake: {
    name: 'Shake',
    properties: {
      animationSpeed: 1,
      shakeIntensity: 0.2,
      shakeFrequency: 10,
      shakeDuration: 1,
      shakeAxes: { x: true, y: true, z: false },
    },
    controls: [
      {
        type: 'number',
        key: 'animationSpeed',
        label: 'Animation Speed',
        min: 0.1,
        max: 10,
        step: 0.1,
      },
      {
        type: 'number',
        key: 'shakeIntensity',
        label: 'Shake Intensity',
        min: 0,
        max: 5,
        step: 0.1,
      },
      {
        type: 'number',
        key: 'shakeFrequency',
        label: 'Shake Frequency',
        min: 0,
        max: 50,
        step: 1,
      },
      // {
      //   type: 'number',
      //   key: 'shakeDuration',
      //   label: 'Shake Duration',
      //   min: 0.1,
      //   max: 5,
      //   step: 0.1,
      // },
      {
        type: 'axes',
        key: 'shakeAxes',
        label: 'Shake Axis',
      },
    ],
  },

  pulse: {
    name: 'Pulse',
    properties: {
      animationSpeed: 1,
      pulseScale: 1.5,
      pulseSpeed: 2,
      pulseCount: 1,
      pulseAxis: { x: true, y: true, z: true },
    },
    controls: [
      {
        type: 'number',
        key: 'animationSpeed',
        label: 'Animation Speed',
        min: 0.1,
        max: 10,
        step: 0.1,
      },
      {
        type: 'number',
        key: 'pulseScale',
        label: 'Pulse Scale',
        min: 1,
        max: 5,
        step: 0.1,
      },
      // {
      //   type: 'number',
      //   key: 'pulseSpeed',
      //   label: 'Pulse Speed',
      //   min: 0.1,
      //   max: 10,
      //   step: 0.1,
      // },
      {
        type: 'number',
        key: 'pulseCount',
        label: 'Pulse Count',
        min: 1,
        max: 100,
        step: 1,
      },
      {
        type: 'axes',
        key: 'pulseAxis',
        label: 'Pulse Axis',
      },
    ],
  },

  playModel: {
    name: 'Play Model',
    properties: {
      clipIndex: 0,
      clipName: '',
      playSpeed: 1.0,
    },
    controls: [
      {
        type: 'clipSelect',
        key: 'clipName',
        label: 'Animation Clip',
      },
      {
        type: 'number',
        key: 'playSpeed',
        label: 'Playback Speed',
        min: 0.1,
        max: 5,
        step: 0.1,
      },
    ],
  },

  orbit: {
    name: 'Orbit',
    properties: {
      animationSpeed: 1,
      orbitCenter: { x: 0, y: 0, z: 0 },
      orbitRadius: 5,
      orbitSpeed: 90,
      orbitAxis: 'Z',
      orbitDirection: 'clockwise',
      orbitTilt: 0,
    },
    controls: [
      {
        type: 'number',
        key: 'animationSpeed',
        label: 'Animation Speed',
        min: 0.1,
        max: 10,
        step: 0.1,
      },
      {
        type: 'position',
        key: 'orbitCenter',
        label: 'Orbit Center',
      },
      {
        type: 'number',
        key: 'orbitRadius',
        label: 'Orbit Radius',
        min: 0.1,
        max: 50,
        step: 0.1,
      },
      {
        type: 'number',
        key: 'orbitSpeed',
        label: 'Orbit Speed',
        min: 0.1,
        max: 180,
        step: 0.1,
      },
      {
        type: 'select',
        key: 'orbitAxis',
        label: 'Orbit Axis',
        options: ['x', 'y', 'z'],
      },
      {
        type: 'select',
        key: 'orbitDirection',
        label: 'Direction',
        options: ['clockwise', 'counterclockwise'],
      },
      {
        type: 'number',
        key: 'orbitTilt',
        label: 'Orbit Tilt',
        min: -180,
        max: 180,
        step: 1,
      },
    ],
  },

  wiggle: {
    name: 'Wiggle',
    properties: {
      animationSpeed: 1,
      wiggleAmount: 1,
      wiggleSpeed: 5,
      wiggleAxis: { x: true, y: false, z: false },
      wiggleRandomness: 0.5,
    },
    controls: [
      {
        type: 'number',
        key: 'animationSpeed',
        label: 'Animation Speed',
        min: 0.1,
        max: 10,
        step: 0.1,
      },
      {
        type: 'number',
        key: 'wiggleAmount',
        label: 'Wiggle Amount',
        min: 0,
        max: 5,
        step: 0.1,
      },
      {
        type: 'number',
        key: 'wiggleSpeed',
        label: 'Wiggle Speed',
        min: 1,
        max: 20,
        step: 1,
      },
      {
        type: 'axes',
        key: 'wiggleAxis',
        label: 'Wiggle Axis',
      },
      {
        type: 'slider',
        key: 'wiggleRandomness',
        label: 'Randomness',
        min: 0,
        max: 1,
        step: 0.01,
      },
    ],
  },

  spring: {
    name: 'Spring',
    properties: {
      animationSpeed: 1,
      springStrength: 1,
      springDamping: 0.5,
      springMass: 1,
      springAxis: { x: true, y: true, z: false },
    },
    controls: [
      {
        type: 'number',
        key: 'animationSpeed',
        label: 'Animation Speed',
        min: 0.1,
        max: 10,
        step: 0.1,
      },
      {
        type: 'number',
        key: 'springStrength',
        label: 'Spring Strength',
        min: 0,
        max: 5,
        step: 0.1,
      },
      {
        type: 'slider',
        key: 'springDamping',
        label: 'Spring Damping',
        min: 0,
        max: 1,
        step: 0.01,
      },
      {
        type: 'number',
        key: 'springMass',
        label: 'Spring Mass',
        min: 0.1,
        max: 5,
        step: 0.1,
      },
      {
        type: 'axes',
        key: 'springAxis',
        label: 'Spring Axis',
      },
    ],
  },
};
